import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { Trans } from "react-i18next";
import { RTF } from "../elements/RTF";
import { Separator } from "../elements/Separator";
import { SimpleLink } from "../elements/SimpleLink";
import {
  HalfWidthClassName,
  HalfWidthTextClassName,
  MainWidthClassName,
} from "../styles";

export const PageCard: React.FC<{
  tagline?: string | null;
  title: string;
  image?: IGatsbyImageData | null;
  alt?: string | null;
  link?: string | null;
  linkTitle?: string | null;
  showLinkAsButton?: boolean | null;
  message?: IRichTextInformation | null;
  fadeOut?: boolean | null;
}> = ({
  tagline,
  title,
  image,
  alt,
  link,
  linkTitle,
  showLinkAsButton,
  message,
  fadeOut,
}) => {
  return (
    <>
      <section
        data-component="Page Card"
        className={classNames("relative", "py-100px", "lg:py-150px")}
      >
        {fadeOut && (
          <div className="absolute bottom-0 left-0 right-0 h-250px bg-gradient-to-t from-hyacinth" />
        )}
        <div className="page-grid max-width relative">
          {tagline && (
            <span
              className={classNames(
                "h3",
                HalfWidthClassName,
                "text-hyacinth",
                "mb-20px",
                "lg:mb-40px"
              )}
            >
              {tagline}
            </span>
          )}
          {title && (
            <h2 className={classNames("h1", HalfWidthClassName)}>{title}</h2>
          )}
          <Separator className={classNames(MainWidthClassName)} />
          {image && link && (
            <Link
              to={link}
              className={classNames(
                MainWidthClassName,
                "mb-30px",
                "lg:mt-30px",
                "lg:mb-60px",
                "aspect-h-9",
                "aspect-w-16",
                "relative"
              )}
            >
              <GatsbyImage
                style={{ position: "absolute" }}
                objectFit="cover"
                image={image}
                alt={(alt ?? title) || "Image"}
                loading="lazy"
              />
            </Link>
          )}
          {image && !link && (
            <div
              className={classNames(
                MainWidthClassName,
                "mb-30px",
                "lg:mt-30px",
                "lg:mb-60px",
                "aspect-h-9",
                "aspect-w-16",
                "relative"
              )}
            >
              <GatsbyImage
                style={{ position: "absolute" }}
                objectFit="cover"
                image={image}
                alt={(alt ?? title) || "Image"}
                loading="lazy"
              />
            </div>
          )}
          {message && (
            <div className={classNames(HalfWidthTextClassName)}>
              <RTF
                content={message}
                className={classNames("mb-30px", "lg:mb-40px")}
              />
              <SimpleLink
                to={link}
                ariaLabel={`Go to page ${title}`}
                isButton={showLinkAsButton ?? false}
              >
                {linkTitle ?? <Trans>Read more</Trans>}
              </SimpleLink>
            </div>
          )}
        </div>{" "}
      </section>
    </>
  );
};
